<template>
  <div style="padding: 20px">
    <!-- 搜索区域 -->
    <div style="margin: 10px 0">
      <el-input
          v-model="searchParams.taskName"
          placeholder="任务名称"
          style="width: 200px; margin-right: 10px"
          clearable
      />
      <el-select
          v-model="searchParams.taskGroup"
          placeholder="任务分组"
          style="width: 150px; margin-right: 10px"
          clearable
      >
        <el-option label="全部" value=""/>
        <el-option label="系统任务" value="system"/>
        <el-option label="WebSocket" value="webSocket"/>
        <el-option label="俱乐部" value="club"/>
        <el-option label="盐场" value="saltWar"/>
        <el-option label="限时活动" value="activity"/>
        <el-option label="答题" value="study"/>
        <el-option label="竞技场" value="arena"/>
        <el-option label="怪异塔" value="evoTower"/>
        <el-option label="爬塔" value="tower"/>
        <el-option label="赛车" value="car"/>
        <el-option label="收菜" value="holding"/>
        <el-option label="日常任务" value="dailyTask"/>
        <el-option label="残券" value="legacy"/>
        <el-option label="微信二维码" value="wechatQrCode"/>
      </el-select>
      <el-select
          v-model="searchParams.status"
          placeholder="任务状态"
          style="width: 150px; margin-right: 10px"
          clearable
      >
        <el-option label="启用" :value="1"/>
        <el-option label="停用" :value="0"/>
      </el-select>
      <el-button type="primary" @click="loadTaskList">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
      <el-button type="success" @click="handleAdd" style="margin-left: 20px">新增任务</el-button>
      <el-button type="info" @click="getAvailableBeans" style="margin-left: 10px">获取可用Bean</el-button>
      <el-button type="warning" @click="reloadTasks" style="margin-left: 10px">重新加载任务</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        @sort-change="handleSortChange"
    >
      <el-table-column
          prop="taskName"
          label="任务名称"
          width="180"
          show-overflow-tooltip
      />
      <el-table-column
          label="执行方式"
          width="150"
      >
        <template #default="scope">
          <div v-if="scope.row.cronExpression">
            <el-tag type="success">Cron表达式</el-tag>
            <div style="font-size: 12px; color: #666; margin-top: 4px">{{ scope.row.cronExpression }}</div>
          </div>
          <div v-else-if="scope.row.fixedRate">
            <el-tag type="primary">固定频率</el-tag>
            <div style="font-size: 12px; color: #666; margin-top: 4px">{{
                formatTimeInterval(scope.row.fixedRate)
              }}
            </div>
          </div>
          <div v-else-if="scope.row.fixedDelay">
            <el-tag type="warning">固定延迟</el-tag>
            <div style="font-size: 12px; color: #666; margin-top: 4px">{{
                formatTimeInterval(scope.row.fixedDelay)
              }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          label="Bean & 方法"
          width="200"
          show-overflow-tooltip
      >
        <template #default="scope">
          <div>{{ scope.row.beanName }}</div>
          <div style="font-size: 12px; color: #409eff;">{{ scope.row.methodName }}()</div>
        </template>
      </el-table-column>
      <el-table-column
          label="时间范围"
          width="200"
      >
        <template #default="scope">
          <div v-if="scope.row.effectiveStartTime || scope.row.effectiveEndTime">
            <div v-if="scope.row.effectiveStartTime">
              开始: {{ formatTime(scope.row.effectiveStartTime) }}
            </div>
            <div v-if="scope.row.effectiveEndTime">
              结束: {{ formatTime(scope.row.effectiveEndTime) }}
            </div>
          </div>
          <div v-else style="color: #909399">长期有效</div>
        </template>
      </el-table-column>
      <el-table-column
          label="执行统计"
          width="200"
      >
        <template #default="scope">
          <div>已执行: {{ scope.row.executionCount || 0 }} 次</div>
          <div v-if="scope.row.maxExecutionCount">
            限制: {{ scope.row.maxExecutionCount }} 次
          </div>
          <div v-if="scope.row.lastExecutionTime" style="font-size: 12px; color: #909399">
            上次: {{ formatTime(scope.row.lastExecutionTime, 'MM-DD HH:mm') }}
          </div>
          <div v-if="scope.row.nextExecutionTime" style="font-size: 12px; color: #909399">
            下次: {{ formatTime(scope.row.nextExecutionTime, 'MM-DD HH:mm') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
          label="状态"
          width="120"
          sortable
      >
        <template #default="scope">
          <el-tag :type="getStatusTagType(scope.row)">
            {{ getStatusText(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip
      />
      <el-table-column
          label="操作"
          width="250"
          fixed="right"
      >
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
              size="small"
              :type="scope.row.status === 1 ? 'warning' : 'success'"
              @click="toggleTaskStatus(scope.row)"
          >
            {{ scope.row.status === 1 ? '停用' : '启用' }}
          </el-button>
          <el-button
              size="small"
              type="primary"
              @click="executeTaskImmediately(scope.row)"
              :disabled="scope.row.status !== 1"
          >
            执行一次
          </el-button>
          <!--          <el-popconfirm-->
          <!--              title="确定删除这个任务吗？"-->
          <!--              @confirm="handleDelete(scope.row)"-->
          <!--          >-->
          <!--            <template #reference>-->
          <!--              <el-button size="small" type="danger">删除</el-button>-->
          <!--            </template>-->
          <!--          </el-popconfirm>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 20px 0; text-align: center">
      <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
        :title="dialogTitle"
        v-model="dialogVisible"
        width="700px"
        :close-on-click-modal="false"
        @closed="handleDialogClosed"
    >
      <el-form
          :model="form"
          ref="formRef"
          :rules="rules"
          label-width="120px"
          label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务名称" prop="taskName">
              <el-input v-model="form.taskName" placeholder="请输入任务名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 新增/编辑弹窗中的分组选择 -->
            <el-form-item label="任务分组" prop="taskGroup">
              <el-select v-model="form.taskGroup" placeholder="请选择分组" style="width: 100%">
                <el-option label="系统任务" value="system"/>
                <el-option label="WebSocket" value="webSocket"/>
                <el-option label="俱乐部" value="club"/>
                <el-option label="盐场" value="saltWar"/>
                <el-option label="限时活动" value="activity"/>
                <el-option label="答题" value="study"/>
                <el-option label="竞技场" value="arena"/>
                <el-option label="怪异塔" value="evoTower"/>
                <el-option label="爬塔" value="tower"/>
                <el-option label="赛车" value="car"/>
                <el-option label="收菜" value="holding"/>
                <el-option label="日常任务" value="dailyTask"/>
                <el-option label="残券" value="legacy"/>
                <el-option label="微信二维码" value="wechatQrCode"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="执行方式">
          <el-radio-group v-model="scheduleType" @change="handleScheduleTypeChange">
            <el-radio label="fixedRate">固定频率</el-radio>
            <el-radio label="fixedDelay">固定延迟</el-radio>
            <el-radio label="cron">Cron表达式</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                v-if="scheduleType === 'fixedRate'"
                label="执行间隔"
                prop="fixedRate"
            >
              <el-input-number
                  v-model="form.fixedRate"
                  :min="1000"
                  :step="1000"
                  style="width: 100%"
                  placeholder="毫秒"
              >
                <template #append>毫秒</template>
              </el-input-number>
              <div style="font-size: 12px; color: #909399; margin-top: 5px">
                例如: 60000 = 1分钟, 3600000 = 1小时
              </div>
            </el-form-item>
            <el-form-item
                v-else-if="scheduleType === 'fixedDelay'"
                label="执行延迟"
                prop="fixedDelay"
            >
              <el-input-number
                  v-model="form.fixedDelay"
                  :min="1000"
                  :step="1000"
                  style="width: 100%"
                  placeholder="毫秒"
              >
                <template #append>毫秒</template>
              </el-input-number>
            </el-form-item>
            <el-form-item
                v-else
                label="Cron表达式"
                prop="cronExpression"
            >
              <el-input
                  v-model="form.cronExpression"
                  placeholder="如: 0 0 2 * * ?"
                  style="width: 100%"
              >
                <template #append>
                  <el-button @click="showCronHelper = true">帮助</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="初始延迟" prop="initialDelay">
              <el-input-number
                  v-model="form.initialDelay"
                  :min="0"
                  :step="1000"
                  style="width: 100%"
                  placeholder="可选"
              >
                <template #append>毫秒</template>
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>时间范围控制</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="启用状态">
              <el-switch
                  v-model="form.status"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="启用"
                  inactive-text="停用"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="限制执行次数">
              <el-switch
                  v-model="enableMaxCount"
                  @change="handleMaxCountChange"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="enableMaxCount">
          <el-col :span="12">
            <el-form-item label="最大执行次数" prop="maxExecutionCount">
              <el-input-number
                  v-model="form.maxExecutionCount"
                  :min="1"
                  style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="生效开始时间">
              <el-date-picker
                  v-model="form.effectiveStartTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  style="width: 100%"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :disabled-date="disabledStartDate"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效结束时间">
              <el-date-picker
                  v-model="form.effectiveEndTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  style="width: 100%"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :disabled-date="disabledEndDate"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>执行信息</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="执行Bean" prop="beanName">
              <el-select
                  v-model="form.beanName"
                  placeholder="请选择或输入Bean名称"
                  style="width: 100%"
                  filterable
                  allow-create
                  @change="handleBeanChange"
              >
                <el-option
                    v-for="bean in availableBeans"
                    :key="bean"
                    :label="bean"
                    :value="bean"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行方法" prop="methodName">
              <el-select
                  v-model="form.methodName"
                  placeholder="请选择方法"
                  style="width: 100%"
                  filterable
                  :loading="loadingMethods"
                  :disabled="!form.beanName"
              >
                <el-option
                    v-for="method in availableMethods"
                    :key="method"
                    :label="method"
                    :value="method"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注">
          <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入任务描述信息"
              maxlength="500"
              show-word-limit
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Cron表达式帮助弹窗 -->
    <el-dialog title="Cron表达式帮助" v-model="showCronHelper" width="600px">
      <div style="max-height: 400px; overflow-y: auto">
        <h4>Cron表达式格式：秒 分 时 日 月 周 年（可选）</h4>
        <el-table :data="cronExamples" border style="width: 100%; margin-top: 10px">
          <el-table-column prop="expression" label="表达式" width="150"/>
          <el-table-column prop="description" label="说明"/>
        </el-table>

        <h4 style="margin-top: 20px">特殊字符说明：</h4>
        <ul>
          <li><strong>*</strong>：匹配任意值</li>
          <li><strong>?</strong>：不指定值（用于日和星期）</li>
          <li><strong>-</strong>：范围，如 10-12 表示 10,11,12</li>
          <li><strong>,</strong>：列表，如 MON,WED,FRI 表示周一、三、五</li>
          <li><strong>/</strong>：步长，如 0/5 表示从0开始每5个单位</li>
          <li><strong>L</strong>：最后，如 6L 表示最后一个周五</li>
          <li><strong>W</strong>：工作日，如 15W 表示最近的工作日</li>
          <li><strong>#</strong>：第几个，如 6#3 表示第3个周五</li>
        </ul>

        <div style="margin-top: 20px; padding: 10px; background: #f5f7fa; border-radius: 4px">
          <strong>常用示例：</strong><br/>
          • 0 0 2 * * ? 每天凌晨2点执行<br/>
          • 0 0/5 * * * ? 每5分钟执行一次<br/>
          • 0 0 9 ? * MON-FRI 工作日早上9点执行<br/>
          • 0 0 12 1 * ? 每月1号中午12点执行
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showCronHelper = false">关闭</el-button>
          <el-button type="primary" @click="showCronHelper = false">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'ScheduleTaskManagement',
  data() {
    return {
      // 搜索参数
      searchParams: {
        taskName: '',
        taskGroup: '',
        status: ''
      },

      // 表格数据
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 弹窗控制
      dialogVisible: false,
      dialogTitle: '新增任务',
      showCronHelper: false,

      // 表单数据
      form: {
        id: null,
        taskName: '',
        taskGroup: 'system',
        cronExpression: '',
        fixedRate: 60000, // 默认1分钟
        fixedDelay: null,
        beanName: '',
        methodName: '',
        initialDelay: 0,
        timeUnit: 'MILLISECONDS',
        status: 1,
        effectiveStartTime: null,
        effectiveEndTime: null,
        maxExecutionCount: null,
        remark: ''
      },

      // 表单验证规则
      rules: {
        taskName: [
          {required: true, message: '请输入任务名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        taskGroup: [
          {required: true, message: '请选择任务分组', trigger: 'change'}
        ],
        beanName: [
          {required: true, message: '请输入或选择Bean名称', trigger: 'blur'}
        ],
        methodName: [
          {required: true, message: '请选择执行方法', trigger: 'change'}
        ],
        fixedRate: [
          {required: false, validator: this.validateFixedRate, trigger: 'blur'}
        ],
        fixedDelay: [
          {required: false, validator: this.validateFixedDelay, trigger: 'blur'}
        ],
        cronExpression: [
          {required: false, validator: this.validateCron, trigger: 'blur'}
        ],
        maxExecutionCount: [
          {type: 'number', min: 1, message: '最小值为1', trigger: 'blur'}
        ]
      },

      // 执行方式
      scheduleType: 'fixedRate',

      // 控制项
      enableMaxCount: false,

      // 可用Bean和方法列表
      availableBeans: [],
      availableMethods: [],
      loadingMethods: false,

      // Cron表达式示例
      cronExamples: [
        {expression: '0 * * * * ?', description: '每分钟执行一次'},
        {expression: '0 0/5 * * * ?', description: '每5分钟执行一次'},
        {expression: '0 0 * * * ?', description: '每小时执行一次'},
        {expression: '0 0 0/2 * * ?', description: '每2小时执行一次'},
        {expression: '0 0 0 * * ?', description: '每天凌晨执行'},
        {expression: '0 0 12 * * ?', description: '每天中午12点执行'},
        {expression: '0 0 9 ? * MON-FRI', description: '工作日早上9点执行'},
        {expression: '0 0 0 1 * ?', description: '每月1号凌晨执行'},
        {expression: '0 0 0 L * ?', description: '每月最后一天执行'},
        {expression: '0 0 0 ? * 2#1', description: '每月第一个周一执行'}
      ]
    }
  },
  created() {
    this.loadTaskList();
    this.getAvailableBeans();
  },
  methods: {

    loadTaskList() {
      this.loading = true
      const searchForm = {...this.searchParams}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/api/schedule/task/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },

    // 重置搜索
    resetSearch() {
      this.searchParams = {
        taskName: '',
        taskGroup: '',
        status: ''
      };
      this.currentPage = 1;
      this.loadTaskList();
    },

    // 获取可用Bean列表
    getAvailableBeans() {
      request.get('/api/schedule/task/available-beans')
          .then(res => {
            if (res.code === '0') {
              this.availableBeans = res.data || [];
            }
          })
          .catch(error => {
            console.error('获取Bean列表失败:', error);
          });
    },

    // Bean选择改变时获取方法列表
    handleBeanChange(beanName) {
      if (!beanName) {
        this.availableMethods = [];
        return;
      }

      this.loadingMethods = true;
      request.get(`/api/schedule/task/bean-methods/${beanName}`)
          .then(res => {
            this.loadingMethods = false;
            if (res.code === '0') {
              this.availableMethods = res.data || [];
              // 清空已选择的方法
              this.form.methodName = '';
            }
          })
          .catch(error => {
            this.loadingMethods = false;
            console.error('获取方法列表失败:', error);
          });
    },

    // 新增任务
    handleAdd() {
      this.dialogTitle = '新增任务';
      this.resetForm();
      this.dialogVisible = true;
    },

    // 编辑任务
    handleEdit(row) {
      this.dialogTitle = '编辑任务';
      this.form = {...row};

      // 判断执行方式
      if (row.cronExpression) {
        this.scheduleType = 'cron';
      } else if (row.fixedRate) {
        this.scheduleType = 'fixedRate';
      } else if (row.fixedDelay) {
        this.scheduleType = 'fixedDelay';
      }

      // 控制最大执行次数开关
      this.enableMaxCount = !!row.maxExecutionCount;

      // 加载该Bean的方法列表
      if (row.beanName) {
        this.handleBeanChange(row.beanName);
      }

      this.dialogVisible = true;
    },

    // 切换任务状态
    toggleTaskStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1;
      const statusText = newStatus === 1 ? '启用' : '停用';

      request.post('/api/schedule/task/toggleStatus', {
        id: row.id,
        status: newStatus
      }).then(res => {
        if (res.code === '0') {
          this.$message.success(`${statusText}成功`);
          this.loadTaskList();
        } else {
          this.$message.error(res.msg || `${statusText}失败`);
        }
      }).catch(error => {
        this.$message.error('网络错误，操作失败');
        console.error(error);
      });
    },

    // 立即执行一次
    executeTaskImmediately(row) {
      request.post(`/api/schedule/task/execute/${row.id}`)
          .then(res => {
            if (res.code === '0') {
              this.$message.success('任务执行请求已发送');
              // 刷新列表以更新执行时间
              setTimeout(() => {
                this.loadTaskList();
              }, 1000);
            } else {
              this.$message.error(res.msg || '执行失败');
            }
          })
          .catch(error => {
            this.$message.error('网络错误，执行失败');
            console.error(error);
          });
    },

    // 删除任务
    handleDelete(row) {
      request.delete(`/api/schedule/task/delete/${row.id}`)
          .then(res => {
            if (res.code === '0') {
              this.$message.success('删除成功');
              this.loadTaskList();
            } else {
              this.$message.error(res.msg || '删除失败');
            }
          })
          .catch(error => {
            this.$message.error('网络错误，删除失败');
            console.error(error);
          });
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return;
        }

        // 根据执行方式设置对应字段
        if (this.scheduleType === 'fixedRate') {
          this.form.cronExpression = '';
          this.form.fixedDelay = null;
          if (!this.form.fixedRate) {
            this.$message.warning('请输入执行间隔');
            return;
          }
        } else if (this.scheduleType === 'fixedDelay') {
          this.form.cronExpression = '';
          this.form.fixedRate = null;
          if (!this.form.fixedDelay) {
            this.$message.warning('请输入执行延迟');
            return;
          }
        } else if (this.scheduleType === 'cron') {
          this.form.fixedRate = null;
          this.form.fixedDelay = null;
          if (!this.form.cronExpression) {
            this.$message.warning('请输入Cron表达式');
            return;
          }
        }

        // 如果没有启用最大执行次数，清空该字段
        if (!this.enableMaxCount) {
          this.form.maxExecutionCount = null;
        }

        const apiUrl = this.form.id ? '/api/schedule/task/update' : '/api/schedule/task/save';

        request.post(apiUrl, this.form)
            .then(res => {
              if (res.code === '0') {
                this.$message.success(this.form.id ? '更新成功' : '新增成功');
                this.dialogVisible = false;
                this.loadTaskList();
              } else {
                this.$message.error(res.msg || '操作失败');
              }
            })
            .catch(error => {
              this.$message.error('网络错误，操作失败');
              console.error(error);
            });
      });
    },

    // 重新加载所有任务
    reloadTasks() {
      this.$confirm('确定要重新加载所有任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/api/schedule/task/reload')
            .then(res => {
              if (res.code === '0') {
                this.$message.success('重新加载成功');
                this.loadTaskList();
              } else {
                this.$message.error(res.msg || '重新加载失败');
              }
            })
            .catch(error => {
              this.$message.error('网络错误，重新加载失败');
              console.error(error);
            });
      }).catch(() => {
        // 用户取消
      });
    },

    // 执行方式改变
    handleScheduleTypeChange(type) {
      // 清空其他字段
      if (type === 'fixedRate') {
        this.form.cronExpression = '';
        this.form.fixedDelay = null;
      } else if (type === 'fixedDelay') {
        this.form.cronExpression = '';
        this.form.fixedRate = null;
      } else if (type === 'cron') {
        this.form.fixedRate = null;
        this.form.fixedDelay = null;
      }
    },

    // 最大执行次数开关改变
    handleMaxCountChange(enabled) {
      if (!enabled) {
        this.form.maxExecutionCount = null;
      } else {
        this.form.maxExecutionCount = 10; // 默认值
      }
    },

    // 表单验证方法
    validateFixedRate(rule, value, callback) {
      if (this.scheduleType === 'fixedRate' && (!value || value < 1000)) {
        callback(new Error('执行间隔至少为1000毫秒'));
      } else {
        callback();
      }
    },

    validateFixedDelay(rule, value, callback) {
      if (this.scheduleType === 'fixedDelay' && (!value || value < 1000)) {
        callback(new Error('执行延迟至少为1000毫秒'));
      } else {
        callback();
      }
    },

    validateCron(rule, value, callback) {
      if (this.scheduleType === 'cron' && !value) {
        callback(new Error('请输入Cron表达式'));
      } else {
        callback();
      }
    },

    // 日期选择器禁用规则
    disabledStartDate(time) {
      if (this.form.effectiveEndTime) {
        return time.getTime() > new Date(this.form.effectiveEndTime).getTime();
      }
      return false;
    },

    disabledEndDate(time) {
      if (this.form.effectiveStartTime) {
        return time.getTime() < new Date(this.form.effectiveStartTime).getTime();
      }
      return false;
    },

    // 弹窗关闭时重置表单
    handleDialogClosed() {
      this.resetForm();
      this.$refs.formRef?.clearValidate();
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: null,
        taskName: '',
        taskGroup: 'system',
        cronExpression: '',
        fixedRate: 60000,
        fixedDelay: null,
        beanName: '',
        methodName: '',
        initialDelay: 0,
        timeUnit: 'MILLISECONDS',
        status: 1,
        effectiveStartTime: null,
        effectiveEndTime: null,
        maxExecutionCount: null,
        remark: ''
      };
      this.scheduleType = 'fixedRate';
      this.enableMaxCount = false;
      this.availableMethods = [];
    },

    handleSizeChange(pageSize) {   // 改变当前每页的个数触发
      this.pageSize = pageSize
      this.loadTaskList()
    },
    handleCurrentChange(pageNum) {  // 改变当前页码触发
      this.currentPage = pageNum
      this.loadTaskList()
    },

    // 表格排序
    handleSortChange({column, prop, order}) {
      // 可以根据需要实现排序功能
      console.log('排序:', prop, order);
    },

    // 获取状态标签类型
    getStatusTagType(task) {
      if (task.status === 0) return 'info';
      if (task.effectiveStatus === 0) return 'warning';
      if (task.effectiveStatus === 2) return 'danger';
      return 'success';
    },

    // 获取状态文本
    getStatusText(task) {
      if (task.status === 0) return '已停用';
      if (task.effectiveStatus === 0) return '未生效';
      if (task.effectiveStatus === 2) return '已过期';

      // 检查是否在运行（需要调用API获取运行状态）
      // 这里可以扩展调用 /api/schedule/task/running 接口
      return '运行中';
    },

// 获取分组标签类型
    getGroupTagType(group) {
      const types = {
        'system': '',            // 默认
        'webSocket': 'primary',      // 蓝色
        'club': 'success',           // 绿色
        'saltWar': 'warning',        // 橙色
        'activity': 'danger',        // 红色
        'study': 'info',             // 青色
        'arena': 'primary',          // 蓝色
        'evoTower': 'success',       // 绿色
        'tower': 'warning',          // 橙色
        'car': 'danger',             // 红色
        'holding': 'info',           // 青色
        'dailyTask': 'primary',      // 蓝色
        'legacy': 'success',         // 绿色
        'wechatQrCode': 'warning',   // 橙色
      };
      return types[group] || '';
    },

// 获取分组文本（显示名称）
    getGroupText(group) {
      const texts = {
        'system': '系统任务',
        'webSocket': 'WebSocket',
        'club': '俱乐部',
        'saltWar': '盐场',
        'activity': '限时活动',
        'study': '答题',
        'arena': '竞技场',
        'evoTower': '怪异塔',
        'tower': '爬塔',
        'car': '赛车',
        'holding': '收菜',
        'dailyTask': '日常任务',
        'legacy': '残券',
        'wechatQrCode': '微信二维码',
      };
      return texts[group] || group; // 如果不在映射中，返回原始值
    },

    // 格式化时间间隔
    formatTimeInterval(ms) {
      if (!ms) return '';

      const seconds = ms / 1000;
      const minutes = seconds / 60;
      const hours = minutes / 60;
      const days = hours / 24;

      if (days >= 1) {
        return `${days.toFixed(1)}天`;
      } else if (hours >= 1) {
        return `${hours.toFixed(1)}小时`;
      } else if (minutes >= 1) {
        return `${minutes.toFixed(0)}分钟`;
      } else {
        return `${seconds.toFixed(0)}秒`;
      }
    },

    // 格式化时间
    formatTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!time) return '';
      return time;
    }
  }
}
</script>

<style scoped>
/* 表格操作按钮间距 */
.el-button + .el-button {
  margin-left: 5px;
}

/* 弹窗表单样式 */
.el-dialog .el-form-item {
  margin-bottom: 18px;
}

/* 分割线样式 */
.el-divider {
  margin: 20px 0;
}

/* 表格行样式 */
.el-table .warning-row {
  background: #fdf6ec;
}

.el-table .danger-row {
  background: #fef0f0;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .el-col {
    width: 100%;
  }

  .el-col-12 {
    width: 100%;
  }
}
</style>
